import 'I18n/init/data/baseLocales';
import 'I18n/init/data/currency';
import 'I18n/init/data/publicLocales';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import { Application } from 'foundations-components/components/Application';
import { createBrowserHistory } from 'history';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import { getPublicRootUrl } from 'marketplace-storefront-base/utils/urls';
import { getTrackerConfig } from 'marketplace-storefront-base/utils/usageTracker';
import { renderRoot } from 'quartz-core/client';
import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { createTracker } from 'usage-tracker-public';
import rhumbConfig from '../rhumb-config.yaml';
import { PublicApp } from './PublicApp';
import { getPublicAuth } from './auth';
import { jsx as _jsx } from "react/jsx-runtime";
function getI18nLang() {
  return window.I18N_MANUAL_LANG || 'en';
}
function getUsageTracker() {
  return createTracker(getTrackerConfig({
    inAppOrPublic: 'public'
  }));
}
export class App {
  constructor() {
    this.publicAuth = null;
  }
  // Kicks off the app. This is intentionally not in the constructor.
  async start() {
    this.publicAuth = await getPublicAuth();
    const I18nProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    const langAvailable = initAppTranslations([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    I18nProvider.setLocale({
      locale: getI18nLang(),
      langEnabled: true
    });
    await langAvailable;
    this.startRouter();
  }
  startRouter() {
    const history = createBrowserHistory({
      basename: getPublicRootUrl(getI18nLang())
    });
    renderRoot( /*#__PURE__*/_jsx(Application, {
      name: "marketplace-storefront-ui",
      children: /*#__PURE__*/_jsx(RhumbProvider, {
        history: historyAdapter(history),
        config: rhumbConfig,
        children: /*#__PURE__*/_jsx(PublicApp, {
          history: history,
          publicAuth: this.publicAuth,
          usageTracker: getUsageTracker()
        })
      })
    }));
  }
}